import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/auth';
import { usePlatformParams } from '@/hooks/use-platform-params';
import { NAVIGATION } from '@/config/routes';

/**
 * 루트 경로(/) 접근 시 로그인 상태에 따라 적절한 페이지로 리다이렉트
 * - 로그인되어 있지 않음: 로그인 페이지로 이동 (플랫폼 파라미터 유지)
 * - 로그인되어 있음: 임직원 목록 페이지로 이동
 */
export function RootRedirect() {
  const { isAuthenticated, isLoading } = useAuthStore();
  const { createUrlWithParams } = usePlatformParams();

  // 로딩 중이면 아무것도 렌더링하지 않음
  if (isLoading) {
    return null;
  }

  // 로그인되어 있으면 임직원 목록 페이지로 이동
  if (isAuthenticated) {
    console.log('[RootRedirect] 로그인된 사용자, 임직원 목록 페이지로 리다이렉트');
    return <Navigate to={NAVIGATION.DEFAULT_AFTER_LOGIN} replace />;
  }

  // 로그인되어 있지 않으면 로그인 페이지로 이동 (플랫폼 파라미터 유지)
  console.log('[RootRedirect] 로그인되지 않은 사용자, 로그인 페이지로 리다이렉트');
  const loginUrl = createUrlWithParams(NAVIGATION.DEFAULT_AFTER_LOGOUT);
  return <Navigate to={loginUrl} replace />;
}